
import React from 'react';
import { Loader2 } from 'lucide-react';

interface PageLoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const PageLoadingOverlay: React.FC<PageLoadingOverlayProps> = ({
  isVisible,
  message = "Loading page..."
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-white/80 backdrop-blur-sm animate-fade-in">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600 mx-auto" />
        <p className="text-sm text-gray-600">{message}</p>
      </div>
    </div>
  );
};
